import { map } from 'lodash';
import { IMAGE_COLLECTION, DEVICE_COLLECTION, PERSON_COLLECTION, ROI_COLLECTION, ZONE_ID, HOTAREA_COLLECTION } from '@blade/common-ui/map-old/2d/src/config/mapConfig';
import { convertLocation, mapDevice, mapPerson } from './tools';
import { creatCollectionChildId, creatCollectionId, creatLayerId } from '@blade/common-ui/map-old/2d/src/utils/mapCollectionUtils';
const getBackground = (url, width, height, id) => {
    const propsId = creatCollectionChildId(IMAGE_COLLECTION, 0);
    return [{
            props: {
                id: propsId,
                type: 'image',
                name: 'background-image',
                visible: true,
                zIndex: 1,
                static: true,
                interactive: false,
                url: url,
                width,
                height,
                opacity: 1.0,
                position: [0, 0, 0]
            }
        }];
};
const generateData = (url, imageSize, deviceList, personList, zoneList, hotAreaList, details) => {
    const { width, height } = imageSize;
    const deviceListMapped = mapDevice(deviceList, imageSize);
    const personListMapped = mapPerson(personList, imageSize, details);
    const roiList = zoneList ? map(zoneList.filter(item => item.roi?.vertices?.length > 0), (zone) => formatBlankRoi(zone, imageSize)) : []; // empty
    const hotMapAreaList = hotAreaList ? map(hotAreaList.filter(item => item.vertices), (hotArea) => formatHotArea(hotArea, imageSize)) : []; // empty
    const layerId = creatLayerId();
    return {
        props: {
            id: layerId,
            type: 'layer',
            name: 'layer-root',
            visible: true,
            dataType: 'device',
            center: [0, 0],
            zoom: 5,
            defaultZoom: 5,
            minZoom: 1,
            maxZoom: 10,
        },
        children: [
            {
                props: {
                    id: creatCollectionId(IMAGE_COLLECTION, 0),
                    type: 'collection',
                    name: IMAGE_COLLECTION,
                    visible: true,
                },
                children: getBackground(url, width, height),
            },
            {
                props: {
                    id: creatCollectionId(DEVICE_COLLECTION, 1),
                    type: 'collection',
                    name: DEVICE_COLLECTION,
                    visible: true,
                },
                children: deviceListMapped,
            },
            {
                props: {
                    id: creatCollectionId(ROI_COLLECTION, 2),
                    type: 'collection',
                    name: ROI_COLLECTION,
                    visible: true,
                },
                children: roiList,
            },
            {
                props: {
                    id: creatCollectionId(PERSON_COLLECTION, 3),
                    type: 'collection',
                    name: PERSON_COLLECTION,
                    visible: true
                },
                children: personListMapped
            },
            {
                props: {
                    id: creatCollectionId(HOTAREA_COLLECTION, 4),
                    type: 'collection',
                    name: HOTAREA_COLLECTION,
                    visible: true,
                },
                children: hotMapAreaList,
            },
        ],
    };
};
export default generateData;
export const ROI_BORDER = {
    width: 4,
    color: 'rgba(50,149,251, .3)',
    transparent: true,
    opacity: 0.8
};
export const ROI_BORDER_TRANSPARENT = {
    width: 4,
    color: 'rgba(50,149,251, 0)',
    transparent: true,
    opacity: 0
};
export const ROI_FILL = {
    color: 'rgba(0,119,250, .3)',
    transparent: true,
    opacity: 0.3,
    show: true
};
export const ROI_TRANSPARENT = {
    color: 'rgba(0,119,250, 0)',
    transparent: true,
    opacity: 0,
    show: false
};
export const ROI_HIGHLIGHT_FILL = {
    color: 'rgba(0,119,250, .8)',
    transparent: true,
    opacity: 0.8
};
const getRoiText = (text) => ({
    text,
    size: 25,
    color: '#ffffff66',
});
export function getBlankRoi(name, id) {
    const propsId = creatCollectionChildId(ROI_COLLECTION, id);
    return {
        props: {
            id: propsId,
            type: 'roi',
            name,
            visible: true,
            static: false,
            border: ROI_BORDER,
            polygon: ROI_FILL,
            position: [0, 0, 1],
            points: [],
            [ZONE_ID]: id,
            roiText: getRoiText(name),
            zIndex: 2,
        }
    };
}
export function formatBlankRoi(zone, imageSize) {
    const { name, roi, id, htmlDom, ...otherProps } = zone;
    const points = map(roi?.vertices, (item) => {
        const { x, y } = convertLocation(item.x, item.y, imageSize);
        return [x, y, 0];
    });
    const propsId = creatCollectionChildId(ROI_COLLECTION, id);
    return {
        props: {
            ...otherProps,
            id: propsId,
            type: 'roi',
            name,
            htmlDom,
            dataType: 'roi',
            visible: true,
            static: false,
            position: [0, 0, 1],
            border: ROI_BORDER,
            polygon: ROI_FILL,
            points,
            roiText: getRoiText(name),
            [ZONE_ID]: id,
            zIndex: 2,
            interactive: true
        }
    };
}
export function formatHotArea(hotArea, imageSize) {
    const { name, vertices, id, taskId, ...otherProps } = hotArea;
    const points = map(vertices, (item) => {
        const { x, y } = convertLocation(item.x, item.y, imageSize);
        return [x, y, 0];
    });
    const propsId = creatCollectionChildId(HOTAREA_COLLECTION, id);
    return {
        props: {
            ...otherProps,
            id: propsId,
            type: 'roi',
            name,
            dataType: 'hotArea',
            taskId,
            visible: true,
            static: false,
            position: [0, 0, 2],
            border: ROI_BORDER_TRANSPARENT,
            polygon: ROI_TRANSPARENT,
            points,
            roiText: { ...getRoiText(name), color: '#ffffff00' },
            [ZONE_ID]: 'task' + id,
            zIndex: 2,
            interactive: true
        }
    };
}
